/**
 * WC-07: Week Header Component
 *
 * Displays the current week's theme and narrative.
 */

import React from 'react';
import { NineSliceBorder } from '../atmosphere/NineSliceBorder';
import './WeekHeader.css';

interface WeekHeaderProps {
  weekId: string;
  theme: string;
  narrative: string;
}

export const WeekHeader: React.FC<WeekHeaderProps> = ({
  weekId,
  theme,
  narrative,
}) => {
  const formatWeekId = (id: string) => {
    // "2024-W15" -> "Week 15, 2024"
    const match = id.match(/(\d{4})-W(\d+)/);
    if (match) {
      return `Week ${parseInt(match[2], 10)}, ${match[1]}`;
    }
    return id;
  };

  return (
    <div className="week-header">
      <div className="week-title-row">
        <h1 className="week-title">THE GAUNTLET</h1>
        <span className="week-id">{formatWeekId(weekId)}</span>
      </div>

      <div className="theme-box">
        <NineSliceBorder
          cornerSrc="/assets/UI/pixel-borders/9s-dark-corner-tl.png"
          edgeTopSrc="/assets/UI/pixel-borders/9s-dark-edge-top.png"
          edgeLeftSrc="/assets/UI/pixel-borders/9s-dark-edge-left.png"
        />
        <h2 className="theme-name">{theme}</h2>
        <p className="theme-narrative">{narrative}</p>
      </div>
    </div>
  );
};
